module.exports = __webpack_public_path__ + "static/media/emissor-nfe.b18afa21.svg";